// badgeData.js
const badgeData = [
	{
		link: "https://getbootstrap.com",
		imageSrc:
			"https://raw.githubusercontent.com/devicons/devicon/master/icons/bootstrap/bootstrap-plain-wordmark.svg",
		alt: "Bootstrap",
		type: "Front-end",
	},
	{
		link: "https://developer.mozilla.org/en-US/docs/Web/CSS",
		imageSrc:
			"https://raw.githubusercontent.com/devicons/devicon/master/icons/css3/css3-original-wordmark.svg",
		alt: "CSS",
		type: "Front-end",
	},

	{
		link: "https://developer.mozilla.org/en-US/docs/Web/HTML",
		imageSrc:
			"https://raw.githubusercontent.com/devicons/devicon/master/icons/html5/html5-original-wordmark.svg",
		alt: "HTML",
		type: "Front-end",
	},

	{
		link: "https://nodejs.org",
		imageSrc:
			"https://raw.githubusercontent.com/devicons/devicon/master/icons/nodejs/nodejs-plain-wordmark.svg",
		alt: "Node.js",
		type: "Back-end ",
	},
	{
		link: "https://www.mysql.com",
		imageSrc:
			"https://raw.githubusercontent.com/devicons/devicon/master/icons/mysql/mysql-original-wordmark.svg",
		alt: "MySQL",
		type: "Database",
	},
	{
		link: "https://flask.palletsprojects.com",
		imageSrc:
			"https://raw.githubusercontent.com/devicons/devicon/master/icons/flask/flask-original-wordmark.svg",
		alt: "Flask",
		type: "Back-end ",
	},
	{
		link: "https://git-scm.com",
		imageSrc:
			"https://raw.githubusercontent.com/devicons/devicon/master/icons/git/git-original-wordmark.svg",
		alt: "Git",
		type: "Tools",
	},
	{
		link: "https://github.com",
		imageSrc:
			"https://raw.githubusercontent.com/devicons/devicon/master/icons/github/github-original-wordmark.svg",
		alt: "GitHub",
		type: "Tools",
	},
	{
		link: "https://developer.mozilla.org/en-US/docs/Web/JavaScript",
		imageSrc:
			"https://raw.githubusercontent.com/devicons/devicon/master/icons/javascript/javascript-original.svg",
		alt: "JavaScript",
		type: "Front-end",
	},
	{
		link: "https://www.linux.org",
		imageSrc:
			"https://raw.githubusercontent.com/devicons/devicon/master/icons/linux/linux-original.svg",
		alt: "Linux",
		type: "Operating System",
	},
	{
		link: "https://www.microsoft.com/en-us/windows",
		imageSrc:
			"https://raw.githubusercontent.com/devicons/devicon/master/icons/windows8/windows8-original.svg",
		alt: "Windows",
		type: "Operating System",
	},
	{
		link: "https://www.mongodb.com",
		imageSrc:
			"https://raw.githubusercontent.com/devicons/devicon/master/icons/mongodb/mongodb-original-wordmark.svg",
		alt: "MongoDB",
		type: "Database",
	},
	{
		link: "https://reactjs.org",
		imageSrc:
			"https://raw.githubusercontent.com/devicons/devicon/master/icons/react/react-original-wordmark.svg",
		alt: "React",
		type: "Front-end",
	},
	{
		link: "https://www.python.org",
		imageSrc:
			"https://raw.githubusercontent.com/devicons/devicon/master/icons/python/python-original-wordmark.svg",
		alt: "Python",
		type: "Back-end ",
	},
	{
		link: "https://code.visualstudio.com/",
		imageSrc:
			"https://raw.githubusercontent.com/devicons/devicon/master/icons/visualstudio/visualstudio-plain.svg",
		alt: "Visual Studio Code",
		type: "Tools",
	},
	{
		link: "https://jupyter.org/",
		imageSrc:
			"https://raw.githubusercontent.com/devicons/devicon/master/icons/jupyter/jupyter-original.svg",
		alt: "Jupyter Notebook",
		type: "Tools",
	},
	{
		link: "https://www.jetbrains.com/pycharm/",
		imageSrc:
			"https://upload.wikimedia.org/wikipedia/commons/1/1d/PyCharm_Icon.svg",
		alt: "PyCharm",
		type: "Tools",
	},

	// Add more badge data objects as needed
];

export default badgeData;
